import type { PropsWithChildren, ComponentProps, FunctionComponent } from 'react'; 
import styles from './AppBar.module.css';

interface AppBarProps extends PropsWithChildren, ComponentProps<"nav"> {};

const AppBar: FunctionComponent<AppBarProps> = ({
    children,
    ...navProps
}) => {
    return (
        <nav {...navProps} className={styles.topNav}>
            { children }
        </nav>
    );
}

export default AppBar; 
